module.exports = __webpack_public_path__ + "img/alur-ppdb.c8d2aed2.png";